import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export interface ILsqDataSource<MessageType = any> {
    connect: (...args: any[]) => Observable<MessageType>;
    disconnect: (...args: any[]) => void;
    data$: Observable<MessageType>;
    noData$?: Observable<boolean>;
    loading$?: Observable<boolean>;
    error$?: Observable<any>;
}

@Injectable({ providedIn: 'root' })
export class LsqDataSource<MessageType> implements ILsqDataSource<MessageType> {
    public data$: Observable<MessageType>;
    public noData$?: Observable<boolean>;
    public loading$?: Observable<boolean>;
    public error$?: Observable<any>;

    private _dataSubscription: Subscription;
    private _noDataSubscription: Subscription;
    private _loadingSubscription: Subscription;
    private _errorSubscription: Subscription;

    constructor(config: Partial<LsqDataSource<MessageType>>) {
        this.data$ = config.data$ ? config.data$.pipe(shareReplay(1)) : undefined;
        this.noData$ = config.noData$ ? config.noData$.pipe(shareReplay(1)) : undefined;
        this.loading$ = config.loading$ ? config.loading$.pipe(shareReplay(1)) : undefined;
        this.error$ = config.error$ ? config.error$.pipe(shareReplay(1)) : undefined;
    }

    public connect(..._: any[]): Observable<MessageType> {
        // Kick off our hot observables.
        if (this.data$) {
            this._dataSubscription = this.data$.subscribe();
        }
        if (this.noData$) {
            this._noDataSubscription = this.noData$.subscribe();
        }
        if (this.loading$) {
            this._loadingSubscription = this.loading$.subscribe();
        }
        if (this.error$) {
            this._errorSubscription = this.error$.subscribe();
        }
        return this.data$;
    }

    public disconnect(..._: any[]): void {
        // Dispose of our hot observables.
        if (this._dataSubscription) {
            this._dataSubscription.unsubscribe();
        }
        if (this._noDataSubscription) {
            this._noDataSubscription.unsubscribe();
        }
        if (this._loadingSubscription) {
            this._loadingSubscription.unsubscribe();
        }
        if (this._errorSubscription) {
            this._errorSubscription.unsubscribe();
        }
    }
}
